import gql from 'graphql-tag';
import { PageInfo } from 'src/app/constants/query/paging/PageInfo';

export enum BranchType {
  CABANG = 'CABANG',
  DEPO = 'DEPO'
}

export enum BranchTypeDisplay {
  CABANG = 'Cabang',
  DEPO = 'Depo'
}

export interface BranchQueryResult {
  active: boolean;
  address: string;
  branchOperationals: BranchOperational[];
  city: string;
  id: string;
  latitude: number;
  longitude: number;
  name: string;
  postalCode: string;
  type: BranchType;
  isImplementPriorityOrder: boolean;
  driverMinimumWaitingTime: number;
  flatIncentive?: boolean;
  isImageRequired: boolean;
}
export interface BranchWithOrderCountQueryResult {
  active: boolean;
  address: string
  branchOperationals: BranchOperational[];
  city: string;
  id: string;
  latitude: number;
  longitude: number;
  name: string;
  postalCode: string;
  type: BranchType;
  isImplementPriorityOrder: boolean;
  driverMinimumWaitingTime: number;
  flatIncentive?: boolean;
  pendingOrdersCount: number;
  todayOrdersCount: number;
  todayOrdersPerWindowRange: Array<{
    label: string;
    count: number;
  }>;
  acceptedOrdersCount: number;
  finishedOrdersCount: number;
  activeDriversCount: number;
}

export interface BranchOperational {
  branchId: number;
  close: string;
  day: string;
  id: number;
  open: string;
}

export const FETCH_BRANCH_PAGE_QUERY = gql`
  query FetchBranchPage($pageInput: PageInput) {
    branchPage(pageInput: $pageInput) {
      currentPage
      results {
        active
        address
        city
        id
        latitude
        longitude
        name
        postalCode
        type
        isImplementPriorityOrder
        driverMinimumWaitingTime
        flatIncentive
        isImageRequired
      }
      totalPages
    }
  }
`;

export const FETCH_BRANCH_WITH_ORDER_COUNT_PAGE_QUERY = gql`
  query FetchBranchWithOrderCountPage($pageInput: PageInput) {
    branchWithOrderCountPage(pageInput: $pageInput) {
      currentPage
      results {
        active
        address
        city
        id
        latitude
        longitude
        name
        postalCode
        type
        isImplementPriorityOrder
        driverMinimumWaitingTime
        flatIncentive
        isImageRequired
        pendingOrdersCount
        todayOrdersCount
        todayOrdersPerWindowRange {
          lable
          count
        }
        acceptedOrdersCount
        finishedOrdersCount
        activeDriversCount
      }
      totalPages
    }
  }
`;

export const FETCH_BRANCH_QUERY = gql`
  query FetchBranch($id: ID!) {
    branch(id: $id) {
      active
      address
      branchOperationals {
        branchId
        close
        day
        id
        open
      }
      city
      id
      latitude
      longitude
      name
      postalCode
      type
      isImplementPriorityOrder
      driverMinimumWaitingTime
      flatIncentive
      isImageRequired
    }
  }
`;

export interface FetchBranchQueryResult {
  branch: BranchQueryResult;
}

export type FetchBranchPageQueryResult = PageInfo<BranchQueryResult>;

export type FetchBranchWithOrderCountPageQueryResult = PageInfo<BranchWithOrderCountQueryResult>;

export interface FetchBranchQueryVariables {
  id: string;
}

export const CREATE_BRANCH_QUERY = gql`
  mutation CreateBranch($input: BranchInput!) {
    createBranch(input: $input) {
      id
    }
  }
`;

export interface CreateBranchQueryResult {
  createBranch: {
    id: string;
  };
}

export interface CreateBranchQueryVariables {
  input: {
    active: boolean;
    address: string;
    branchOperationals: CreateBranchOperationalQueryVariables[];
    city: string;
    latitude: number;
    longitude: number;
    name: string;
    postalCode: string;
    type: BranchType;
    isImplementPriorityOrder: boolean;
    driverMinimumWaitingTime: number;
    flatIncentive?: boolean;
    isImageRequired?: boolean;
  };
}

export interface CreateBranchOperationalQueryVariables {
  close: string;
  day: string;
  open: string;
}

export const UPDATE_BRANCH_QUERY = gql`
  mutation UpdateBranch($id: ID!, $input: BranchInput!) {
    updateBranch(id: $id, input: $input) {
      id
    }
  }
`;

export interface UpdateBranchQueryResult {
  updateBranch: {
    id: string;
  };
}

export interface UpdateBranchQueryVariables {
  id: string;
  input: {
    active: boolean;
    address: string;
    branchOperationals: CreateBranchOperationalQueryVariables[];
    city: string;
    latitude: number;
    longitude: number;
    name: string;
    postalCode: string;
    type: BranchType;
    isImplementPriorityOrder: boolean;
    driverMinimumWaitingTime: number;
    flatIncentive?: boolean;
    isImageRequired?: boolean;
  };
}

export enum BranchLogAction {
  ENABLE_PRIORITY_ORDER = 'ENABLE_PRIORITY_ORDER',
  DISABLE_PRIORITY_ORDER = 'DISABLE_PRIORITY_ORDER',
  ENABLE_FLAT_INCENTIVE = 'ENABLE_FLAT_INCENTIVE',
  DISABLE_FLAT_INCENTIVE = 'DISABLE_FLAT_INCENTIVE'
}

export const BranchLogActionDisplay: Record<BranchLogAction, string> = {
  [BranchLogAction.ENABLE_PRIORITY_ORDER]: 'Enable Priority Order',
  [BranchLogAction.DISABLE_PRIORITY_ORDER]: 'Disable Priority Order',
  [BranchLogAction.ENABLE_FLAT_INCENTIVE]: 'Enable Flat Incentive',
  [BranchLogAction.DISABLE_FLAT_INCENTIVE]: 'Disable Flat Incentive'
};

export interface BranchLogQueryResult {
  id: string;
  action: string;
  createdAt: string;
  user: {
    id: string;
    username: string;
  } | null;
}

export interface FetchBranchLogPageQueryResult {
  branchLogPage: PageInfo<BranchLogQueryResult>;
}

export interface FetchBranchLogPageQueryVariables {
  branchId: string;
  pageInput?: {
    page?: number;
    size?: number;
  };
}

export const FETCH_BRANCH_LOG_PAGE_QUERY = gql`
  query FetchBranchLogPage($branchId: ID!, $pageInput: PageInput) {
    branchLogPage(branchId: $branchId, pageInput: $pageInput) {
      currentPage
      totalPages
      results {
        id
        action
        createdAt
        user {
          id
          username
        }
      }
    }
  }
`;
